'use strict';

import { Entity } from '../Entity';

export type UserSourcesScope = 'U' | 'G';

export class UserSources extends Entity {
  protected sourceId: number;
  protected userId: number;
  protected sourceName: string;
  protected sourceScope: UserSourcesScope;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.sourceId = data.sourceId;
    this.userId = data.userId;
    this.sourceName = data.sourceName;
    this.sourceScope = data.sourceScope;
  }

  public getSourceId(): number {
    return this.sourceId;
  }

  public getUserId(): number {
    return this.userId;
  }

  public getSourceName(): string {
    return this.sourceName;
  }

  public getSourceScope(): UserSourcesScope {
    return this.sourceScope;
  }
}
